var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Tooltip } from '@mui/material';
import MultiSelectFilter from './MultiSelectFilter';
import useCFFilters from './useCFFilters';
var CountryCFFilter = function (props) {
    var _a;
    var _b = useCFFilters({}), countryValues = _b.countryValues, getEuropeanCountryOptions = _b.getEuropeanCountryOptions;
    var countryOptions = getEuropeanCountryOptions(props === null || props === void 0 ? void 0 : props.countryData);
    var transformedOptions = React.useMemo(function () {
        var _a;
        return (_a = (countryOptions !== null && countryOptions !== void 0 ? countryOptions : [])) === null || _a === void 0 ? void 0 : _a.map(function (data) {
            var _a;
            return (__assign(__assign({}, data), { isDisabled: (_a = props === null || props === void 0 ? void 0 : props.disabledCountries) === null || _a === void 0 ? void 0 : _a.includes(data === null || data === void 0 ? void 0 : data.value) }));
        });
    }, [props === null || props === void 0 ? void 0 : props.disabledCountries, countryOptions]);
    return (React.createElement(MultiSelectFilter, { label: (_a = props.label) !== null && _a !== void 0 ? _a : 'Countries', options: transformedOptions, getOptionDisabled: function (option) { return option === null || option === void 0 ? void 0 : option.isDisabled; }, onApply: function (values) {
            props === null || props === void 0 ? void 0 : props.handleFilterApply({
                name: props === null || props === void 0 ? void 0 : props.name,
                value: (values !== null && values !== void 0 ? values : []).filter(function (v) { return (v === null || v === void 0 ? void 0 : v.value) !== 'countryGroup-7'; }),
                prevValue: values
            });
        }, values: countryValues, optionEndItem: function (option) {
            var isEurope = (option === null || option === void 0 ? void 0 : option.label) === 'Europe';
            if (!(option === null || option === void 0 ? void 0 : option.isDisabled) && !isEurope)
                return;
            return (React.createElement(Tooltip, { className: "lfc-pointer-events-auto", title: isEurope
                    ? 'You will get results for all the countries in Europe.'
                    : 'Due to student nationality filter some of the courses might not be available' },
                React.createElement("i", { className: "fi fi-rr-info lfc-flex lfc-pointer-events-auto" })));
        } }));
};
export default CountryCFFilter;
//# sourceMappingURL=CountryCFFilter.js.map